export const updateMapping = (builder) => ({
    updateMapping: builder.mutation({
        query: (data) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: '/update_eu_in_eru',
                method: 'POST',
                body: data,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            };
        }
    })
});
